export default "__VITE_ASSET__CfDggS$b__"